import { useState, useEffect } from 'react';

const useResponsiveInViewConfigMargin = () => {
  const [inViewConfigMargin, setInViewConfigMargin] = useState('75%');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setInViewConfigMargin('30%'); // desktop margin
      } else {
        setInViewConfigMargin('75%'); // mobile margin
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Call the function once at initial render

    return () => window.removeEventListener('resize', handleResize); // Cleanup function
  }, []);

  return inViewConfigMargin;
};

export { useResponsiveInViewConfigMargin };
